import { Component, ElementRef, forwardRef, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'ui2-search-input',
  templateUrl: './ui2-search-input.component.html',
  styleUrls: ['./ui2-search-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => Ui2SearchInputComponent)
    }
  ]
})
export class Ui2SearchInputComponent implements ControlValueAccessor, OnInit, OnDestroy {
  /*
    Model management
  */
  public localValue: string;
  set model(val: string) {
    this.localValue = val;
  }

  /*
    String inputs
  */
  @Input()
  public name: string;

  @Input()
  public placeholder: string;

  /*
    Readonly
  */
  @HostBinding('class.readonly')
  @Input()
  public readonly: boolean;

  /*
    Auto focus mechanism
  */

  @ViewChild('inputSearch')
  inputSearch: ElementRef;

  private focusSubject: Subject<boolean> = new Subject();

  @Input()
  set focus(value: boolean) {
    this.focusSubject.next(value);
  }

  /*
    Subscriptions
  */
  private subscription: Subscription = new Subscription();

  public ngOnInit() {
    this.subscription.add(
      this.focusSubject.subscribe((value) => {
        if (this.inputSearch && value) {
          this.inputSearch.nativeElement.focus();
        } else if (this.inputSearch && !value) {
          this.inputSearch.nativeElement.blur();
        }
      })
    );
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public onChange: any = () => {};
  public onTouch: any = () => {};

  writeValue(obj: string): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public clear() {
    this.localValue = null;
    this.onChange(this.localValue);
    this.onTouch(this.localValue);
  }

  public change() {
    this.onChange(this.localValue);
    this.onTouch(this.localValue);
  }
}
